<template>
  <div style="width: 100%;">
    <el-row style="padding: 5px;" :gutter="10" v-if="!onlyTable">  
        <el-col :span="8">
          <el-input v-model="udi" placeholder="UDI"></el-input>
        </el-col> 
        <el-col :span="14">
          <el-input v-model="remark" placeholder="Remark"></el-input>
        </el-col> 
        <el-col :span="2" >
          <el-button type="success" @click="addTableData()" >{{$t('button.create')}}</el-button>
        </el-col> 
      </el-row>   
    <el-table ref="singleTable" :data="tableData.data"  border  highlight-current-row  :empty-text="$t('msg.noDataFound')">
      <el-table-column v-for="(v, i) in tableData.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i">
        <template slot-scope="scope">
          <span v-if="v.field== 'mainChargeBol' ">
            <el-checkbox  v-model="scope.row[v.field]"  @change="checkboxChange(scope.row, scope)"></el-checkbox>
          </span>
          <span v-else>{{ scope.row[v.field] }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('action')" width="80" v-if="!onlyTable">
        <template slot-scope="scope">    
          <el-button type="danger" @click="delTableData(scope.row, scope.$index, true)">{{$t('button.delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {apiFindFeedbackUdiByFeedbackId } from "../../../utils/api.js";
import authHeader from "../../../services/auth-header";


export default {
  props: {    
    pFeedbackId: {
      type: String
    },
    onlyTable: {
      type: Boolean,
      Default: false
    }
  },
  data() {   
    return {
      tableData: {
        sel: null,
        columns: [
          { field: "udi", title: 'UDI', width: 200},         
          { field: "remark", title: 'Remark'  }        
        ],
        data: []
      },
      currentIndex:-1,
      remark:'',
      udi:''
    };
  },  
  components: {
    
  }, 
  mounted() {
    if(this.pFeedbackId != null && this.pFeedbackId != ''){      
      apiFindFeedbackUdiByFeedbackId({ headers: authHeader(), feedbackId: this.pFeedbackId}).then((response) => { 
        if(response.status== 200 && response.data != null && response.data.length > 0){
          this.tableData.data = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    }    
    
  },
  methods: {
    checkboxChange(row, value){
      row.action = 'U';
      if(row.mainChargeBol){
        var isDuplicate = false;
        this.tableData.data.forEach((item, index) => {
          if(item.type == row.type && item.mainChargeBol && item.remark != row.remark  ){
            isDuplicate = true;
          }
        });
        if(isDuplicate){
          this.$message({ type: "error", message: this.$i18n.t('msg.incxWindowMainChargeisDuplicate'), duration: 800});
          row.mainChargeBol = false;
        }
      }else{

      }
    },  
    addTableData() {
      if(this.udi != '' || this.remark != ''){
        let isDuplicate = false;
        this.tableData.data.forEach((item, index) => {             
          if(item.udi == this.udi ){
            isDuplicate = true;
          }
        });
        if(isDuplicate){
          this.$message({ type: "error", message: this.$i18n.t('msg.isDuplicateCannotAdd'), duration: 800});
        }else{
          let j = {
            feedbackId: this.feedbackId,
            udi: this.udi,
            remark: this.remark,
            action:'A',
            id:''
          };
          this.tableData.data.splice(0, 0, j);
          this.currentIndex = 0;
          this.udi = '';
          this.remark = '';
        }
      }else{
        this.$message({ type: "error", message: this.$i18n.t('msg.fillDataFirst'), duration: 800});         
      }      
    },    
    delTableData(row, index){  
      this.tableData.data.splice(index, 1);
    }
  }
};
</script>
